import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { EntityRenewalService } from '../entity-renewal.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { Subscription } from 'rxjs';
import { MessageModel } from '../../../model/models';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import * as $ from 'jquery';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';

@Component({
  selector: 'app-corporation-entity-renewal',
  templateUrl: './corporation-entity-renewal.component.html',
  styleUrls: ['./corporation-entity-renewal.component.css']
})
export class CorporationEntityRenewalComponent implements OnInit, OnDestroy {

  agree: boolean = false;
  userMessages: Array<MessageModel> = [];

  notifySubmitEntityQuestionnaireAnswersSubscription : Subscription = new Subscription();
  notifySubmitIndividualQuestionnaireAnswersSubscription : Subscription = new Subscription();
  notifyEntityQuestionListSubscription : Subscription = new Subscription();
  notifySelectInactiveOfficesToRenewSubscription : Subscription = new Subscription();
  submitEntityQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  submitIndividualQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  entityRenewalquestions: Array<QuestionnaireQuestionModel> = [];
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  
  notifyIndividualQuestionListSubscription : Subscription = new Subscription();
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  
  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  individualCorporationStatusResponse : SubmitIndividualCorporationStatusResponseModel =null;

  constructor(private entityRenewalService: EntityRenewalService,
    private individualRenewalService : IndividualRenewalService,
    private router: Router,
    private startFunctionService: StartFunctionService,
    private currentPageWatcher : CurrentPageWatcherService) {

      this.notifyIndividualCorporationStatusResponseSubscription=this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
        (data: SubmitIndividualCorporationStatusResponseModel)=>{
          this.individualCorporationStatusResponse=data;
  
        }
      );

    this.notifySubmitEntityQuestionnaireAnswersSubscription = this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().subscribe(submitQuestionnaireAnswersResp => {
      this.submitEntityQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });

    this.notifyEntityQuestionListSubscription = this.entityRenewalService.getNotifyQuestionList().subscribe(questionListData => {
      this.entityRenewalquestions = questionListData;
    });

    this.notifySelectInactiveOfficesToRenewSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().subscribe(
      selectInactiveOfficesData => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesData;
      });
    this.notifyIndividualQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
      this.individualRenewalQuestions = questionListData;
    });

    this.notifySubmitIndividualQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitIndividualQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });
  }

  ngOnInit() {
  }

  continue(){
    console.log("agree?? = ", this.agree);
    if (this.agree == false) {
      let userMessage: MessageModel = {};
      userMessage.Alert = 3;
      userMessage.Description = "You must check the box below to continue.";
      this.userMessages.push(userMessage);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
    }

    else {

      
         //redirect to Review
         this.router.navigate(["/reviewEntityRenewal"]).then(()=>{
           this.startFunctionService.getNotifyStepInProgress().emit(true);
           this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalquestions);
           this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
           this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
           this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
           this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
           this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
         })
    }
  }

  goBack() {
    this.router.navigate(["/verifyEntityRenewalQuestionnaire"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalquestions);
      this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
      this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
    })
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();
  }
  
  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
    
  }
}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/corporation-entity-renewal/corporation-entity-renewal.component.ts